/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Venda no Zap API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthResponse,
  BookAppointment201,
  BookAppointmentBody,
  CatalogPushSubscribeRequest,
  CatalogResponse,
  Category,
  CreateAddressRequest,
  CreateCategoryRequest,
  CreateCustomerBody,
  CreateFinancialCategoryRequest,
  CreateOrderRequest,
  CreateProductRequest,
  CreateTransactionRequest,
  CreateUnitRequest,
  CreateUnitResponse,
  Customer,
  CustomerAddress,
  CustomerAuthResponse,
  CustomerLoginRequest,
  CustomerStoreSummary,
  CustomerWithOrders,
  CustomerWithStats,
  DashboardStats,
  DeleteCustomerParams,
  ErrorResponse,
  FinancialCategory,
  FinancialSummary,
  GetBookingAvailableDates200,
  GetBookingAvailableDatesParams,
  GetBookingPage200,
  GetBookingPageParams,
  GetBookingSlots200,
  GetBookingSlotsParams,
  GetCatalogParams,
  HealthStatus,
  ListCustomersParams,
  ListFinancialCategoriesParams,
  ListOrdersParams,
  ListProductsParams,
  ListTransactionsParams,
  MagicLinkRequest,
  Order,
  OrderWithItems,
  Product,
  PushSubscribeRequest,
  RegisterRequest,
  ReorderRequest,
  Store,
  SuccessResponse,
  SwitchUnit200,
  SwitchUnitBody,
  Transaction,
  TransactionsResponse,
  UnitsListResponse,
  UpdateOrderStatusRequest,
  UpdateStoreRequest,
  UploadImageBody,
  UploadResponse,
  UserWithStore,
  ValidateWhatsappRequest,
  ValidateWhatsappResponse,
  VapidKeyResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a new store owner
 */
export const getRegisterUrl = () => {
  return `/api/auth/register`;
};

export const register = async (
  registerRequest: RegisterRequest,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getRegisterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerRequest),
  });
};

export const getRegisterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterRequest> },
  TContext
> => {
  const mutationKey = ["register"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof register>>,
    { data: BodyType<RegisterRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return register(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof register>>
>;
export type RegisterMutationBody = BodyType<RegisterRequest>;
export type RegisterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Register a new store owner
 */
export const useRegister = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterRequest> },
  TContext
> => {
  return useMutation(getRegisterMutationOptions(options));
};

/**
 * @summary Request a magic link login via WhatsApp
 */
export const getRequestMagicLinkUrl = () => {
  return `/api/auth/request-magic-link`;
};

export const requestMagicLink = async (
  magicLinkRequest: MagicLinkRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getRequestMagicLinkUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(magicLinkRequest),
  });
};

export const getRequestMagicLinkMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestMagicLink>>,
    TError,
    { data: BodyType<MagicLinkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestMagicLink>>,
  TError,
  { data: BodyType<MagicLinkRequest> },
  TContext
> => {
  const mutationKey = ["requestMagicLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestMagicLink>>,
    { data: BodyType<MagicLinkRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestMagicLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestMagicLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestMagicLink>>
>;
export type RequestMagicLinkMutationBody = BodyType<MagicLinkRequest>;
export type RequestMagicLinkMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Request a magic link login via WhatsApp
 */
export const useRequestMagicLink = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestMagicLink>>,
    TError,
    { data: BodyType<MagicLinkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestMagicLink>>,
  TError,
  { data: BodyType<MagicLinkRequest> },
  TContext
> => {
  return useMutation(getRequestMagicLinkMutationOptions(options));
};

/**
 * @summary Verify a magic link token and create session
 */
export const getVerifyMagicLinkUrl = (token: string) => {
  return `/api/auth/verify-magic-link/${token}`;
};

export const verifyMagicLink = async (
  token: string,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getVerifyMagicLinkUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getVerifyMagicLinkQueryKey = (token: string) => {
  return [`/api/auth/verify-magic-link/${token}`] as const;
};

export const getVerifyMagicLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof verifyMagicLink>>,
  TError = ErrorType<ErrorResponse>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof verifyMagicLink>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getVerifyMagicLinkQueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyMagicLink>>> = ({
    signal,
  }) => verifyMagicLink(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof verifyMagicLink>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type VerifyMagicLinkQueryResult = NonNullable<
  Awaited<ReturnType<typeof verifyMagicLink>>
>;
export type VerifyMagicLinkQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Verify a magic link token and create session
 */

export function useVerifyMagicLink<
  TData = Awaited<ReturnType<typeof verifyMagicLink>>,
  TError = ErrorType<ErrorResponse>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof verifyMagicLink>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getVerifyMagicLinkQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Logout
 */
export const getLogoutUrl = () => {
  return `/api/auth/logout`;
};

export const logout = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Logout
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options));
};

/**
 * @summary Get current user
 */
export const getGetMeUrl = () => {
  return `/api/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<UserWithStore> => {
  return customFetch<UserWithStore>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Validate a WhatsApp number via UAZAPI
 */
export const getValidateWhatsappUrl = () => {
  return `/api/auth/validate-whatsapp`;
};

export const validateWhatsapp = async (
  validateWhatsappRequest: ValidateWhatsappRequest,
  options?: RequestInit,
): Promise<ValidateWhatsappResponse> => {
  return customFetch<ValidateWhatsappResponse>(getValidateWhatsappUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(validateWhatsappRequest),
  });
};

export const getValidateWhatsappMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateWhatsapp>>,
    TError,
    { data: BodyType<ValidateWhatsappRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateWhatsapp>>,
  TError,
  { data: BodyType<ValidateWhatsappRequest> },
  TContext
> => {
  const mutationKey = ["validateWhatsapp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateWhatsapp>>,
    { data: BodyType<ValidateWhatsappRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return validateWhatsapp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateWhatsappMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateWhatsapp>>
>;
export type ValidateWhatsappMutationBody = BodyType<ValidateWhatsappRequest>;
export type ValidateWhatsappMutationError = ErrorType<unknown>;

/**
 * @summary Validate a WhatsApp number via UAZAPI
 */
export const useValidateWhatsapp = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateWhatsapp>>,
    TError,
    { data: BodyType<ValidateWhatsappRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof validateWhatsapp>>,
  TError,
  { data: BodyType<ValidateWhatsappRequest> },
  TContext
> => {
  return useMutation(getValidateWhatsappMutationOptions(options));
};

/**
 * @summary Get current store settings
 */
export const getGetStoreUrl = () => {
  return `/api/stores/me`;
};

export const getStore = async (options?: RequestInit): Promise<Store> => {
  return customFetch<Store>(getGetStoreUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetStoreQueryKey = () => {
  return [`/api/stores/me`] as const;
};

export const getGetStoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getStore>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStoreQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStore>>> = ({
    signal,
  }) => getStore({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStore>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStore>>
>;
export type GetStoreQueryError = ErrorType<unknown>;

/**
 * @summary Get current store settings
 */

export function useGetStore<
  TData = Awaited<ReturnType<typeof getStore>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStoreQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update store settings
 */
export const getUpdateStoreUrl = () => {
  return `/api/stores/me`;
};

export const updateStore = async (
  updateStoreRequest: UpdateStoreRequest,
  options?: RequestInit,
): Promise<Store> => {
  return customFetch<Store>(getUpdateStoreUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateStoreRequest),
  });
};

export const getUpdateStoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStore>>,
    TError,
    { data: BodyType<UpdateStoreRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStore>>,
  TError,
  { data: BodyType<UpdateStoreRequest> },
  TContext
> => {
  const mutationKey = ["updateStore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStore>>,
    { data: BodyType<UpdateStoreRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateStore(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStore>>
>;
export type UpdateStoreMutationBody = BodyType<UpdateStoreRequest>;
export type UpdateStoreMutationError = ErrorType<unknown>;

/**
 * @summary Update store settings
 */
export const useUpdateStore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStore>>,
    TError,
    { data: BodyType<UpdateStoreRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStore>>,
  TError,
  { data: BodyType<UpdateStoreRequest> },
  TContext
> => {
  return useMutation(getUpdateStoreMutationOptions(options));
};

/**
 * @summary List product categories for the store
 */
export const getListCategoriesUrl = () => {
  return `/api/categories`;
};

export const listCategories = async (
  options?: RequestInit,
): Promise<Category[]> => {
  return customFetch<Category[]>(getListCategoriesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCategoriesQueryKey = () => {
  return [`/api/categories`] as const;
};

export const getListCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCategories>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCategoriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCategories>>> = ({
    signal,
  }) => listCategories({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCategories>>
>;
export type ListCategoriesQueryError = ErrorType<unknown>;

/**
 * @summary List product categories for the store
 */

export function useListCategories<
  TData = Awaited<ReturnType<typeof listCategories>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCategories>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCategoriesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new product category
 */
export const getCreateCategoryUrl = () => {
  return `/api/categories`;
};

export const createCategory = async (
  createCategoryRequest: CreateCategoryRequest,
  options?: RequestInit,
): Promise<Category> => {
  return customFetch<Category>(getCreateCategoryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCategoryRequest),
  });
};

export const getCreateCategoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategory>>,
    TError,
    { data: BodyType<CreateCategoryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCategory>>,
  TError,
  { data: BodyType<CreateCategoryRequest> },
  TContext
> => {
  const mutationKey = ["createCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCategory>>,
    { data: BodyType<CreateCategoryRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCategory>>
>;
export type CreateCategoryMutationBody = BodyType<CreateCategoryRequest>;
export type CreateCategoryMutationError = ErrorType<unknown>;

/**
 * @summary Create a new product category
 */
export const useCreateCategory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategory>>,
    TError,
    { data: BodyType<CreateCategoryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCategory>>,
  TError,
  { data: BodyType<CreateCategoryRequest> },
  TContext
> => {
  return useMutation(getCreateCategoryMutationOptions(options));
};

/**
 * @summary Update category
 */
export const getUpdateCategoryUrl = (id: string) => {
  return `/api/categories/${id}`;
};

export const updateCategory = async (
  id: string,
  createCategoryRequest: CreateCategoryRequest,
  options?: RequestInit,
): Promise<Category> => {
  return customFetch<Category>(getUpdateCategoryUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCategoryRequest),
  });
};

export const getUpdateCategoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCategory>>,
    TError,
    { id: string; data: BodyType<CreateCategoryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCategory>>,
  TError,
  { id: string; data: BodyType<CreateCategoryRequest> },
  TContext
> => {
  const mutationKey = ["updateCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCategory>>,
    { id: string; data: BodyType<CreateCategoryRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCategory(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCategory>>
>;
export type UpdateCategoryMutationBody = BodyType<CreateCategoryRequest>;
export type UpdateCategoryMutationError = ErrorType<unknown>;

/**
 * @summary Update category
 */
export const useUpdateCategory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCategory>>,
    TError,
    { id: string; data: BodyType<CreateCategoryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCategory>>,
  TError,
  { id: string; data: BodyType<CreateCategoryRequest> },
  TContext
> => {
  return useMutation(getUpdateCategoryMutationOptions(options));
};

/**
 * @summary Delete category
 */
export const getDeleteCategoryUrl = (id: string) => {
  return `/api/categories/${id}`;
};

export const deleteCategory = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteCategoryUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCategoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCategory>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCategory>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCategory(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCategory>>
>;

export type DeleteCategoryMutationError = ErrorType<unknown>;

/**
 * @summary Delete category
 */
export const useDeleteCategory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCategory>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteCategoryMutationOptions(options));
};

/**
 * @summary List products for the store
 */
export const getListProductsUrl = (params?: ListProductsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/products?${stringifiedParams}`
    : `/api/products`;
};

export const listProducts = async (
  params?: ListProductsParams,
  options?: RequestInit,
): Promise<Product[]> => {
  return customFetch<Product[]>(getListProductsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListProductsQueryKey = (params?: ListProductsParams) => {
  return [`/api/products`, ...(params ? [params] : [])] as const;
};

export const getListProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof listProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProductsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProducts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({
    signal,
  }) => listProducts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProducts>>
>;
export type ListProductsQueryError = ErrorType<unknown>;

/**
 * @summary List products for the store
 */

export function useListProducts<
  TData = Awaited<ReturnType<typeof listProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProductsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProducts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProductsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a product
 */
export const getCreateProductUrl = () => {
  return `/api/products`;
};

export const createProduct = async (
  createProductRequest: CreateProductRequest,
  options?: RequestInit,
): Promise<Product> => {
  return customFetch<Product>(getCreateProductUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createProductRequest),
  });
};

export const getCreateProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProduct>>,
    TError,
    { data: BodyType<CreateProductRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProduct>>,
  TError,
  { data: BodyType<CreateProductRequest> },
  TContext
> => {
  const mutationKey = ["createProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProduct>>,
    { data: BodyType<CreateProductRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createProduct(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProduct>>
>;
export type CreateProductMutationBody = BodyType<CreateProductRequest>;
export type CreateProductMutationError = ErrorType<unknown>;

/**
 * @summary Create a product
 */
export const useCreateProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProduct>>,
    TError,
    { data: BodyType<CreateProductRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createProduct>>,
  TError,
  { data: BodyType<CreateProductRequest> },
  TContext
> => {
  return useMutation(getCreateProductMutationOptions(options));
};

/**
 * @summary Reorder products within categories
 */
export const getReorderProductsUrl = () => {
  return `/api/products/reorder`;
};

export const reorderProducts = async (
  reorderRequest: ReorderRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getReorderProductsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderRequest),
  });
};

export const getReorderProductsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderProducts>>,
    TError,
    { data: BodyType<ReorderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderProducts>>,
  TError,
  { data: BodyType<ReorderRequest> },
  TContext
> => {
  const mutationKey = ["reorderProducts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderProducts>>,
    { data: BodyType<ReorderRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return reorderProducts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderProductsMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderProducts>>
>;
export type ReorderProductsMutationBody = BodyType<ReorderRequest>;
export type ReorderProductsMutationError = ErrorType<unknown>;

/**
 * @summary Reorder products within categories
 */
export const useReorderProducts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderProducts>>,
    TError,
    { data: BodyType<ReorderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderProducts>>,
  TError,
  { data: BodyType<ReorderRequest> },
  TContext
> => {
  return useMutation(getReorderProductsMutationOptions(options));
};

/**
 * @summary Get a single product
 */
export const getGetProductUrl = (id: string) => {
  return `/api/products/${id}`;
};

export const getProduct = async (
  id: string,
  options?: RequestInit,
): Promise<Product> => {
  return customFetch<Product>(getGetProductUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetProductQueryKey = (id: string) => {
  return [`/api/products/${id}`] as const;
};

export const getGetProductQueryOptions = <
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProduct>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({
    signal,
  }) => getProduct(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProduct>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProduct>>
>;
export type GetProductQueryError = ErrorType<unknown>;

/**
 * @summary Get a single product
 */

export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProduct>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProductQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a product
 */
export const getUpdateProductUrl = (id: string) => {
  return `/api/products/${id}`;
};

export const updateProduct = async (
  id: string,
  createProductRequest: CreateProductRequest,
  options?: RequestInit,
): Promise<Product> => {
  return customFetch<Product>(getUpdateProductUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createProductRequest),
  });
};

export const getUpdateProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProduct>>,
    TError,
    { id: string; data: BodyType<CreateProductRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProduct>>,
  TError,
  { id: string; data: BodyType<CreateProductRequest> },
  TContext
> => {
  const mutationKey = ["updateProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProduct>>,
    { id: string; data: BodyType<CreateProductRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateProduct(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProduct>>
>;
export type UpdateProductMutationBody = BodyType<CreateProductRequest>;
export type UpdateProductMutationError = ErrorType<unknown>;

/**
 * @summary Update a product
 */
export const useUpdateProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProduct>>,
    TError,
    { id: string; data: BodyType<CreateProductRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProduct>>,
  TError,
  { id: string; data: BodyType<CreateProductRequest> },
  TContext
> => {
  return useMutation(getUpdateProductMutationOptions(options));
};

/**
 * @summary Delete a product
 */
export const getDeleteProductUrl = (id: string) => {
  return `/api/products/${id}`;
};

export const deleteProduct = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteProductUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProduct>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProduct>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProduct>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteProduct(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProduct>>
>;

export type DeleteProductMutationError = ErrorType<unknown>;

/**
 * @summary Delete a product
 */
export const useDeleteProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProduct>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProduct>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteProductMutationOptions(options));
};

/**
 * @summary List orders for the store
 */
export const getListOrdersUrl = (params?: ListOrdersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/orders?${stringifiedParams}`
    : `/api/orders`;
};

export const listOrders = async (
  params?: ListOrdersParams,
  options?: RequestInit,
): Promise<Order[]> => {
  return customFetch<Order[]>(getListOrdersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListOrdersQueryKey = (params?: ListOrdersParams) => {
  return [`/api/orders`, ...(params ? [params] : [])] as const;
};

export const getListOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrders>>> = ({
    signal,
  }) => listOrders(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrders>>
>;
export type ListOrdersQueryError = ErrorType<unknown>;

/**
 * @summary List orders for the store
 */

export function useListOrders<
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single order
 */
export const getGetOrderUrl = (id: string) => {
  return `/api/orders/${id}`;
};

export const getOrder = async (
  id: string,
  options?: RequestInit,
): Promise<OrderWithItems> => {
  return customFetch<OrderWithItems>(getGetOrderUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetOrderQueryKey = (id: string) => {
  return [`/api/orders/${id}`] as const;
};

export const getGetOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({
    signal,
  }) => getOrder(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrder>>
>;
export type GetOrderQueryError = ErrorType<unknown>;

/**
 * @summary Get a single order
 */

export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrderQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update order status
 */
export const getUpdateOrderStatusUrl = (id: string) => {
  return `/api/orders/${id}/status`;
};

export const updateOrderStatus = async (
  id: string,
  updateOrderStatusRequest: UpdateOrderStatusRequest,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getUpdateOrderStatusUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateOrderStatusRequest),
  });
};

export const getUpdateOrderStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrderStatus>>,
    TError,
    { id: string; data: BodyType<UpdateOrderStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrderStatus>>,
  TError,
  { id: string; data: BodyType<UpdateOrderStatusRequest> },
  TContext
> => {
  const mutationKey = ["updateOrderStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrderStatus>>,
    { id: string; data: BodyType<UpdateOrderStatusRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateOrderStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrderStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrderStatus>>
>;
export type UpdateOrderStatusMutationBody = BodyType<UpdateOrderStatusRequest>;
export type UpdateOrderStatusMutationError = ErrorType<unknown>;

/**
 * @summary Update order status
 */
export const useUpdateOrderStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrderStatus>>,
    TError,
    { id: string; data: BodyType<UpdateOrderStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOrderStatus>>,
  TError,
  { id: string; data: BodyType<UpdateOrderStatusRequest> },
  TContext
> => {
  return useMutation(getUpdateOrderStatusMutationOptions(options));
};

/**
 * @summary List customers for the store
 */
export const getListCustomersUrl = (params?: ListCustomersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/customers?${stringifiedParams}`
    : `/api/customers`;
};

export const listCustomers = async (
  params?: ListCustomersParams,
  options?: RequestInit,
): Promise<CustomerWithStats[]> => {
  return customFetch<CustomerWithStats[]>(getListCustomersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCustomersQueryKey = (params?: ListCustomersParams) => {
  return [`/api/customers`, ...(params ? [params] : [])] as const;
};

export const getListCustomersQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCustomersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCustomersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomers>>> = ({
    signal,
  }) => listCustomers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCustomersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomers>>
>;
export type ListCustomersQueryError = ErrorType<unknown>;

/**
 * @summary List customers for the store
 */

export function useListCustomers<
  TData = Awaited<ReturnType<typeof listCustomers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCustomersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCustomersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new customer
 */
export const getCreateCustomerUrl = () => {
  return `/api/customers`;
};

export const createCustomer = async (
  createCustomerBody: CreateCustomerBody,
  options?: RequestInit,
): Promise<Customer> => {
  return customFetch<Customer>(getCreateCustomerUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCustomerBody),
  });
};

export const getCreateCustomerMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomer>>,
    TError,
    { data: BodyType<CreateCustomerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomer>>,
  TError,
  { data: BodyType<CreateCustomerBody> },
  TContext
> => {
  const mutationKey = ["createCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomer>>,
    { data: BodyType<CreateCustomerBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCustomer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomer>>
>;
export type CreateCustomerMutationBody = BodyType<CreateCustomerBody>;
export type CreateCustomerMutationError = ErrorType<void>;

/**
 * @summary Create a new customer
 */
export const useCreateCustomer = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomer>>,
    TError,
    { data: BodyType<CreateCustomerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCustomer>>,
  TError,
  { data: BodyType<CreateCustomerBody> },
  TContext
> => {
  return useMutation(getCreateCustomerMutationOptions(options));
};

/**
 * @summary Get customer details
 */
export const getGetCustomerUrl = (id: string) => {
  return `/api/customers/${id}`;
};

export const getCustomer = async (
  id: string,
  options?: RequestInit,
): Promise<CustomerWithOrders> => {
  return customFetch<CustomerWithOrders>(getGetCustomerUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCustomerQueryKey = (id: string) => {
  return [`/api/customers/${id}`] as const;
};

export const getGetCustomerQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomer>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCustomerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({
    signal,
  }) => getCustomer(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomer>>
>;
export type GetCustomerQueryError = ErrorType<unknown>;

/**
 * @summary Get customer details
 */

export function useGetCustomer<
  TData = Awaited<ReturnType<typeof getCustomer>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete a customer
 */
export const getDeleteCustomerUrl = (
  id: string,
  params?: DeleteCustomerParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/customers/${id}?${stringifiedParams}`
    : `/api/customers/${id}`;
};

export const deleteCustomer = async (
  id: string,
  params?: DeleteCustomerParams,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteCustomerUrl(id, params), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCustomerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomer>>,
    TError,
    { id: string; params?: DeleteCustomerParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomer>>,
  TError,
  { id: string; params?: DeleteCustomerParams },
  TContext
> => {
  const mutationKey = ["deleteCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomer>>,
    { id: string; params?: DeleteCustomerParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return deleteCustomer(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomer>>
>;

export type DeleteCustomerMutationError = ErrorType<unknown>;

/**
 * @summary Delete a customer
 */
export const useDeleteCustomer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomer>>,
    TError,
    { id: string; params?: DeleteCustomerParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomer>>,
  TError,
  { id: string; params?: DeleteCustomerParams },
  TContext
> => {
  return useMutation(getDeleteCustomerMutationOptions(options));
};

/**
 * @summary List financial transactions
 */
export const getListTransactionsUrl = (params?: ListTransactionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/financial/transactions?${stringifiedParams}`
    : `/api/financial/transactions`;
};

export const listTransactions = async (
  params?: ListTransactionsParams,
  options?: RequestInit,
): Promise<TransactionsResponse> => {
  return customFetch<TransactionsResponse>(getListTransactionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTransactionsQueryKey = (
  params?: ListTransactionsParams,
) => {
  return [`/api/financial/transactions`, ...(params ? [params] : [])] as const;
};

export const getListTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTransactions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTransactionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTransactions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTransactionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTransactions>>
  > = ({ signal }) => listTransactions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTransactions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTransactions>>
>;
export type ListTransactionsQueryError = ErrorType<unknown>;

/**
 * @summary List financial transactions
 */

export function useListTransactions<
  TData = Awaited<ReturnType<typeof listTransactions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTransactionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTransactions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTransactionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a financial transaction
 */
export const getCreateTransactionUrl = () => {
  return `/api/financial/transactions`;
};

export const createTransaction = async (
  createTransactionRequest: CreateTransactionRequest,
  options?: RequestInit,
): Promise<Transaction> => {
  return customFetch<Transaction>(getCreateTransactionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTransactionRequest),
  });
};

export const getCreateTransactionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTransaction>>,
    TError,
    { data: BodyType<CreateTransactionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTransaction>>,
  TError,
  { data: BodyType<CreateTransactionRequest> },
  TContext
> => {
  const mutationKey = ["createTransaction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTransaction>>,
    { data: BodyType<CreateTransactionRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createTransaction(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTransactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTransaction>>
>;
export type CreateTransactionMutationBody = BodyType<CreateTransactionRequest>;
export type CreateTransactionMutationError = ErrorType<unknown>;

/**
 * @summary Create a financial transaction
 */
export const useCreateTransaction = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTransaction>>,
    TError,
    { data: BodyType<CreateTransactionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTransaction>>,
  TError,
  { data: BodyType<CreateTransactionRequest> },
  TContext
> => {
  return useMutation(getCreateTransactionMutationOptions(options));
};

/**
 * @summary Update a transaction
 */
export const getUpdateTransactionUrl = (id: string) => {
  return `/api/financial/transactions/${id}`;
};

export const updateTransaction = async (
  id: string,
  createTransactionRequest: CreateTransactionRequest,
  options?: RequestInit,
): Promise<Transaction> => {
  return customFetch<Transaction>(getUpdateTransactionUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTransactionRequest),
  });
};

export const getUpdateTransactionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTransaction>>,
    TError,
    { id: string; data: BodyType<CreateTransactionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTransaction>>,
  TError,
  { id: string; data: BodyType<CreateTransactionRequest> },
  TContext
> => {
  const mutationKey = ["updateTransaction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTransaction>>,
    { id: string; data: BodyType<CreateTransactionRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTransaction(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTransactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTransaction>>
>;
export type UpdateTransactionMutationBody = BodyType<CreateTransactionRequest>;
export type UpdateTransactionMutationError = ErrorType<unknown>;

/**
 * @summary Update a transaction
 */
export const useUpdateTransaction = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTransaction>>,
    TError,
    { id: string; data: BodyType<CreateTransactionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTransaction>>,
  TError,
  { id: string; data: BodyType<CreateTransactionRequest> },
  TContext
> => {
  return useMutation(getUpdateTransactionMutationOptions(options));
};

/**
 * @summary Delete a transaction
 */
export const getDeleteTransactionUrl = (id: string) => {
  return `/api/financial/transactions/${id}`;
};

export const deleteTransaction = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteTransactionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTransactionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTransaction>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTransaction>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteTransaction"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTransaction>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTransaction(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTransactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTransaction>>
>;

export type DeleteTransactionMutationError = ErrorType<unknown>;

/**
 * @summary Delete a transaction
 */
export const useDeleteTransaction = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTransaction>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTransaction>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteTransactionMutationOptions(options));
};

/**
 * @summary List financial categories
 */
export const getListFinancialCategoriesUrl = (
  params?: ListFinancialCategoriesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/financial/categories?${stringifiedParams}`
    : `/api/financial/categories`;
};

export const listFinancialCategories = async (
  params?: ListFinancialCategoriesParams,
  options?: RequestInit,
): Promise<FinancialCategory[]> => {
  return customFetch<FinancialCategory[]>(
    getListFinancialCategoriesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListFinancialCategoriesQueryKey = (
  params?: ListFinancialCategoriesParams,
) => {
  return [`/api/financial/categories`, ...(params ? [params] : [])] as const;
};

export const getListFinancialCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listFinancialCategories>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFinancialCategoriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFinancialCategories>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListFinancialCategoriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFinancialCategories>>
  > = ({ signal }) =>
    listFinancialCategories(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFinancialCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFinancialCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFinancialCategories>>
>;
export type ListFinancialCategoriesQueryError = ErrorType<unknown>;

/**
 * @summary List financial categories
 */

export function useListFinancialCategories<
  TData = Awaited<ReturnType<typeof listFinancialCategories>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFinancialCategoriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFinancialCategories>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFinancialCategoriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a financial category
 */
export const getCreateFinancialCategoryUrl = () => {
  return `/api/financial/categories`;
};

export const createFinancialCategory = async (
  createFinancialCategoryRequest: CreateFinancialCategoryRequest,
  options?: RequestInit,
): Promise<FinancialCategory> => {
  return customFetch<FinancialCategory>(getCreateFinancialCategoryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createFinancialCategoryRequest),
  });
};

export const getCreateFinancialCategoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFinancialCategory>>,
    TError,
    { data: BodyType<CreateFinancialCategoryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFinancialCategory>>,
  TError,
  { data: BodyType<CreateFinancialCategoryRequest> },
  TContext
> => {
  const mutationKey = ["createFinancialCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFinancialCategory>>,
    { data: BodyType<CreateFinancialCategoryRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createFinancialCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFinancialCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFinancialCategory>>
>;
export type CreateFinancialCategoryMutationBody =
  BodyType<CreateFinancialCategoryRequest>;
export type CreateFinancialCategoryMutationError = ErrorType<unknown>;

/**
 * @summary Create a financial category
 */
export const useCreateFinancialCategory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFinancialCategory>>,
    TError,
    { data: BodyType<CreateFinancialCategoryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFinancialCategory>>,
  TError,
  { data: BodyType<CreateFinancialCategoryRequest> },
  TContext
> => {
  return useMutation(getCreateFinancialCategoryMutationOptions(options));
};

/**
 * @summary Get dashboard financial summary
 */
export const getGetFinancialSummaryUrl = () => {
  return `/api/financial/summary`;
};

export const getFinancialSummary = async (
  options?: RequestInit,
): Promise<FinancialSummary> => {
  return customFetch<FinancialSummary>(getGetFinancialSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetFinancialSummaryQueryKey = () => {
  return [`/api/financial/summary`] as const;
};

export const getGetFinancialSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getFinancialSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFinancialSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFinancialSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFinancialSummary>>
  > = ({ signal }) => getFinancialSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFinancialSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFinancialSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFinancialSummary>>
>;
export type GetFinancialSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Get dashboard financial summary
 */

export function useGetFinancialSummary<
  TData = Awaited<ReturnType<typeof getFinancialSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFinancialSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFinancialSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save a push subscription for owner or customer
 */
export const getSubscribePushUrl = () => {
  return `/api/push/subscribe`;
};

export const subscribePush = async (
  pushSubscribeRequest: PushSubscribeRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getSubscribePushUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(pushSubscribeRequest),
  });
};

export const getSubscribePushMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribePush>>,
    TError,
    { data: BodyType<PushSubscribeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof subscribePush>>,
  TError,
  { data: BodyType<PushSubscribeRequest> },
  TContext
> => {
  const mutationKey = ["subscribePush"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof subscribePush>>,
    { data: BodyType<PushSubscribeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return subscribePush(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubscribePushMutationResult = NonNullable<
  Awaited<ReturnType<typeof subscribePush>>
>;
export type SubscribePushMutationBody = BodyType<PushSubscribeRequest>;
export type SubscribePushMutationError = ErrorType<unknown>;

/**
 * @summary Save a push subscription for owner or customer
 */
export const useSubscribePush = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribePush>>,
    TError,
    { data: BodyType<PushSubscribeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof subscribePush>>,
  TError,
  { data: BodyType<PushSubscribeRequest> },
  TContext
> => {
  return useMutation(getSubscribePushMutationOptions(options));
};

/**
 * @summary Get VAPID public key for push subscription
 */
export const getGetVapidPublicKeyUrl = () => {
  return `/api/push/vapid-public-key`;
};

export const getVapidPublicKey = async (
  options?: RequestInit,
): Promise<VapidKeyResponse> => {
  return customFetch<VapidKeyResponse>(getGetVapidPublicKeyUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetVapidPublicKeyQueryKey = () => {
  return [`/api/push/vapid-public-key`] as const;
};

export const getGetVapidPublicKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getVapidPublicKey>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getVapidPublicKey>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVapidPublicKeyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVapidPublicKey>>
  > = ({ signal }) => getVapidPublicKey({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVapidPublicKey>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVapidPublicKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVapidPublicKey>>
>;
export type GetVapidPublicKeyQueryError = ErrorType<unknown>;

/**
 * @summary Get VAPID public key for push subscription
 */

export function useGetVapidPublicKey<
  TData = Awaited<ReturnType<typeof getVapidPublicKey>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getVapidPublicKey>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVapidPublicKeyQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upload and convert image to WebP
 */
export const getUploadImageUrl = () => {
  return `/api/upload/image`;
};

export const uploadImage = async (
  uploadImageBody: UploadImageBody,
  options?: RequestInit,
): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append(`file`, uploadImageBody.file);

  return customFetch<UploadResponse>(getUploadImageUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadImage>>,
    TError,
    { data: BodyType<UploadImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadImage>>,
  TError,
  { data: BodyType<UploadImageBody> },
  TContext
> => {
  const mutationKey = ["uploadImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadImage>>,
    { data: BodyType<UploadImageBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadImage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadImage>>
>;
export type UploadImageMutationBody = BodyType<UploadImageBody>;
export type UploadImageMutationError = ErrorType<unknown>;

/**
 * @summary Upload and convert image to WebP
 */
export const useUploadImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadImage>>,
    TError,
    { data: BodyType<UploadImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadImage>>,
  TError,
  { data: BodyType<UploadImageBody> },
  TContext
> => {
  return useMutation(getUploadImageMutationOptions(options));
};

/**
 * @summary List all units in the current store group
 */
export const getListUnitsUrl = () => {
  return `/api/units`;
};

export const listUnits = async (
  options?: RequestInit,
): Promise<UnitsListResponse> => {
  return customFetch<UnitsListResponse>(getListUnitsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListUnitsQueryKey = () => {
  return [`/api/units`] as const;
};

export const getListUnitsQueryOptions = <
  TData = Awaited<ReturnType<typeof listUnits>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUnitsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnits>>> = ({
    signal,
  }) => listUnits({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUnits>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUnitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUnits>>
>;
export type ListUnitsQueryError = ErrorType<unknown>;

/**
 * @summary List all units in the current store group
 */

export function useListUnits<
  TData = Awaited<ReturnType<typeof listUnits>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listUnits>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUnitsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new unit (professional plan only)
 */
export const getCreateUnitUrl = () => {
  return `/api/units`;
};

export const createUnit = async (
  createUnitRequest: CreateUnitRequest,
  options?: RequestInit,
): Promise<CreateUnitResponse> => {
  return customFetch<CreateUnitResponse>(getCreateUnitUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createUnitRequest),
  });
};

export const getCreateUnitMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUnit>>,
    TError,
    { data: BodyType<CreateUnitRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUnit>>,
  TError,
  { data: BodyType<CreateUnitRequest> },
  TContext
> => {
  const mutationKey = ["createUnit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUnit>>,
    { data: BodyType<CreateUnitRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createUnit(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUnitMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUnit>>
>;
export type CreateUnitMutationBody = BodyType<CreateUnitRequest>;
export type CreateUnitMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a new unit (professional plan only)
 */
export const useCreateUnit = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUnit>>,
    TError,
    { data: BodyType<CreateUnitRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUnit>>,
  TError,
  { data: BodyType<CreateUnitRequest> },
  TContext
> => {
  return useMutation(getCreateUnitMutationOptions(options));
};

/**
 * @summary Switch active unit in the session
 */
export const getSwitchUnitUrl = () => {
  return `/api/units/switch`;
};

export const switchUnit = async (
  switchUnitBody: SwitchUnitBody,
  options?: RequestInit,
): Promise<SwitchUnit200> => {
  return customFetch<SwitchUnit200>(getSwitchUnitUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(switchUnitBody),
  });
};

export const getSwitchUnitMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof switchUnit>>,
    TError,
    { data: BodyType<SwitchUnitBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof switchUnit>>,
  TError,
  { data: BodyType<SwitchUnitBody> },
  TContext
> => {
  const mutationKey = ["switchUnit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof switchUnit>>,
    { data: BodyType<SwitchUnitBody> }
  > = (props) => {
    const { data } = props ?? {};

    return switchUnit(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SwitchUnitMutationResult = NonNullable<
  Awaited<ReturnType<typeof switchUnit>>
>;
export type SwitchUnitMutationBody = BodyType<SwitchUnitBody>;
export type SwitchUnitMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Switch active unit in the session
 */
export const useSwitchUnit = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof switchUnit>>,
    TError,
    { data: BodyType<SwitchUnitBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof switchUnit>>,
  TError,
  { data: BodyType<SwitchUnitBody> },
  TContext
> => {
  return useMutation(getSwitchUnitMutationOptions(options));
};

/**
 * @summary Get public catalog data for a store
 */
export const getGetCatalogUrl = (slug: string, params?: GetCatalogParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/catalog/${slug}?${stringifiedParams}`
    : `/api/catalog/${slug}`;
};

export const getCatalog = async (
  slug: string,
  params?: GetCatalogParams,
  options?: RequestInit,
): Promise<CatalogResponse> => {
  return customFetch<CatalogResponse>(getGetCatalogUrl(slug, params), {
    ...options,
    method: "GET",
  });
};

export const getGetCatalogQueryKey = (
  slug: string,
  params?: GetCatalogParams,
) => {
  return [`/api/catalog/${slug}`, ...(params ? [params] : [])] as const;
};

export const getGetCatalogQueryOptions = <
  TData = Awaited<ReturnType<typeof getCatalog>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: GetCatalogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCatalog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCatalogQueryKey(slug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalog>>> = ({
    signal,
  }) => getCatalog(slug, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCatalog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCatalogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalog>>
>;
export type GetCatalogQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get public catalog data for a store
 */

export function useGetCatalog<
  TData = Awaited<ReturnType<typeof getCatalog>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  params?: GetCatalogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCatalog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCatalogQueryOptions(slug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new order from the catalog
 */
export const getCreateOrderUrl = (slug: string) => {
  return `/api/catalog/${slug}/orders`;
};

export const createOrder = async (
  slug: string,
  createOrderRequest: CreateOrderRequest,
  options?: RequestInit,
): Promise<OrderWithItems> => {
  return customFetch<OrderWithItems>(getCreateOrderUrl(slug), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createOrderRequest),
  });
};

export const getCreateOrderMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrder>>,
    TError,
    { slug: string; data: BodyType<CreateOrderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrder>>,
  TError,
  { slug: string; data: BodyType<CreateOrderRequest> },
  TContext
> => {
  const mutationKey = ["createOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrder>>,
    { slug: string; data: BodyType<CreateOrderRequest> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return createOrder(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrder>>
>;
export type CreateOrderMutationBody = BodyType<CreateOrderRequest>;
export type CreateOrderMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a new order from the catalog
 */
export const useCreateOrder = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrder>>,
    TError,
    { slug: string; data: BodyType<CreateOrderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOrder>>,
  TError,
  { slug: string; data: BodyType<CreateOrderRequest> },
  TContext
> => {
  return useMutation(getCreateOrderMutationOptions(options));
};

/**
 * @summary Get orders for the authenticated customer in this store group
 */
export const getGetCustomerOrdersUrl = (slug: string) => {
  return `/api/catalog/${slug}/orders`;
};

export const getCustomerOrders = async (
  slug: string,
  options?: RequestInit,
): Promise<OrderWithItems[]> => {
  return customFetch<OrderWithItems[]>(getGetCustomerOrdersUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetCustomerOrdersQueryKey = (slug: string) => {
  return [`/api/catalog/${slug}/orders`] as const;
};

export const getGetCustomerOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerOrders>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCustomerOrdersQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerOrders>>
  > = ({ signal }) => getCustomerOrders(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerOrders>>
>;
export type GetCustomerOrdersQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get orders for the authenticated customer in this store group
 */

export function useGetCustomerOrders<
  TData = Awaited<ReturnType<typeof getCustomerOrders>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomerOrdersQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get saved addresses for the authenticated customer
 */
export const getGetCustomerAddressesUrl = (slug: string) => {
  return `/api/catalog/${slug}/addresses`;
};

export const getCustomerAddresses = async (
  slug: string,
  options?: RequestInit,
): Promise<CustomerAddress[]> => {
  return customFetch<CustomerAddress[]>(getGetCustomerAddressesUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetCustomerAddressesQueryKey = (slug: string) => {
  return [`/api/catalog/${slug}/addresses`] as const;
};

export const getGetCustomerAddressesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAddresses>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerAddresses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerAddressesQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerAddresses>>
  > = ({ signal }) => getCustomerAddresses(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAddresses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerAddressesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAddresses>>
>;
export type GetCustomerAddressesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get saved addresses for the authenticated customer
 */

export function useGetCustomerAddresses<
  TData = Awaited<ReturnType<typeof getCustomerAddresses>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerAddresses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomerAddressesQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save a new address for the authenticated customer
 */
export const getCreateCustomerAddressUrl = (slug: string) => {
  return `/api/catalog/${slug}/addresses`;
};

export const createCustomerAddress = async (
  slug: string,
  createAddressRequest: CreateAddressRequest,
  options?: RequestInit,
): Promise<CustomerAddress> => {
  return customFetch<CustomerAddress>(getCreateCustomerAddressUrl(slug), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAddressRequest),
  });
};

export const getCreateCustomerAddressMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomerAddress>>,
    TError,
    { slug: string; data: BodyType<CreateAddressRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomerAddress>>,
  TError,
  { slug: string; data: BodyType<CreateAddressRequest> },
  TContext
> => {
  const mutationKey = ["createCustomerAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomerAddress>>,
    { slug: string; data: BodyType<CreateAddressRequest> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return createCustomerAddress(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomerAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomerAddress>>
>;
export type CreateCustomerAddressMutationBody = BodyType<CreateAddressRequest>;
export type CreateCustomerAddressMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Save a new address for the authenticated customer
 */
export const useCreateCustomerAddress = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomerAddress>>,
    TError,
    { slug: string; data: BodyType<CreateAddressRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCustomerAddress>>,
  TError,
  { slug: string; data: BodyType<CreateAddressRequest> },
  TContext
> => {
  return useMutation(getCreateCustomerAddressMutationOptions(options));
};

/**
 * @summary Save push subscription for the authenticated catalog customer
 */
export const getCatalogPushSubscribeUrl = (slug: string) => {
  return `/api/catalog/${slug}/push-subscribe`;
};

export const catalogPushSubscribe = async (
  slug: string,
  catalogPushSubscribeRequest: CatalogPushSubscribeRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getCatalogPushSubscribeUrl(slug), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(catalogPushSubscribeRequest),
  });
};

export const getCatalogPushSubscribeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof catalogPushSubscribe>>,
    TError,
    { slug: string; data: BodyType<CatalogPushSubscribeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof catalogPushSubscribe>>,
  TError,
  { slug: string; data: BodyType<CatalogPushSubscribeRequest> },
  TContext
> => {
  const mutationKey = ["catalogPushSubscribe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof catalogPushSubscribe>>,
    { slug: string; data: BodyType<CatalogPushSubscribeRequest> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return catalogPushSubscribe(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CatalogPushSubscribeMutationResult = NonNullable<
  Awaited<ReturnType<typeof catalogPushSubscribe>>
>;
export type CatalogPushSubscribeMutationBody =
  BodyType<CatalogPushSubscribeRequest>;
export type CatalogPushSubscribeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Save push subscription for the authenticated catalog customer
 */
export const useCatalogPushSubscribe = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof catalogPushSubscribe>>,
    TError,
    { slug: string; data: BodyType<CatalogPushSubscribeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof catalogPushSubscribe>>,
  TError,
  { slug: string; data: BodyType<CatalogPushSubscribeRequest> },
  TContext
> => {
  return useMutation(getCatalogPushSubscribeMutationOptions(options));
};

/**
 * @summary Log in (or create) a public-customer identity via WhatsApp
 */
export const getCustomerAuthLoginUrl = () => {
  return `/api/customer/auth/login`;
};

export const customerAuthLogin = async (
  customerLoginRequest: CustomerLoginRequest,
  options?: RequestInit,
): Promise<CustomerAuthResponse> => {
  return customFetch<CustomerAuthResponse>(getCustomerAuthLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(customerLoginRequest),
  });
};

export const getCustomerAuthLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof customerAuthLogin>>,
    TError,
    { data: BodyType<CustomerLoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof customerAuthLogin>>,
  TError,
  { data: BodyType<CustomerLoginRequest> },
  TContext
> => {
  const mutationKey = ["customerAuthLogin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof customerAuthLogin>>,
    { data: BodyType<CustomerLoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return customerAuthLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CustomerAuthLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof customerAuthLogin>>
>;
export type CustomerAuthLoginMutationBody = BodyType<CustomerLoginRequest>;
export type CustomerAuthLoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Log in (or create) a public-customer identity via WhatsApp
 */
export const useCustomerAuthLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof customerAuthLogin>>,
    TError,
    { data: BodyType<CustomerLoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof customerAuthLogin>>,
  TError,
  { data: BodyType<CustomerLoginRequest> },
  TContext
> => {
  return useMutation(getCustomerAuthLoginMutationOptions(options));
};

/**
 * @summary Get the currently authenticated customer
 */
export const getCustomerAuthMeUrl = () => {
  return `/api/customer/auth/me`;
};

export const customerAuthMe = async (
  options?: RequestInit,
): Promise<CustomerAuthResponse> => {
  return customFetch<CustomerAuthResponse>(getCustomerAuthMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getCustomerAuthMeQueryKey = () => {
  return [`/api/customer/auth/me`] as const;
};

export const getCustomerAuthMeQueryOptions = <
  TData = Awaited<ReturnType<typeof customerAuthMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof customerAuthMe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCustomerAuthMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof customerAuthMe>>> = ({
    signal,
  }) => customerAuthMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof customerAuthMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CustomerAuthMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof customerAuthMe>>
>;
export type CustomerAuthMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the currently authenticated customer
 */

export function useCustomerAuthMe<
  TData = Awaited<ReturnType<typeof customerAuthMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof customerAuthMe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCustomerAuthMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Log out the current customer (does not affect store-owner session)
 */
export const getCustomerAuthLogoutUrl = () => {
  return `/api/customer/auth/logout`;
};

export const customerAuthLogout = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getCustomerAuthLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCustomerAuthLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof customerAuthLogout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof customerAuthLogout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["customerAuthLogout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof customerAuthLogout>>,
    void
  > = () => {
    return customerAuthLogout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CustomerAuthLogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof customerAuthLogout>>
>;

export type CustomerAuthLogoutMutationError = ErrorType<unknown>;

/**
 * @summary Log out the current customer (does not affect store-owner session)
 */
export const useCustomerAuthLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof customerAuthLogout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof customerAuthLogout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCustomerAuthLogoutMutationOptions(options));
};

/**
 * @summary List all stores where the authenticated customer has placed orders or appointments
 */
export const getCustomerListStoresUrl = () => {
  return `/api/customer/stores`;
};

export const customerListStores = async (
  options?: RequestInit,
): Promise<CustomerStoreSummary[]> => {
  return customFetch<CustomerStoreSummary[]>(getCustomerListStoresUrl(), {
    ...options,
    method: "GET",
  });
};

export const getCustomerListStoresQueryKey = () => {
  return [`/api/customer/stores`] as const;
};

export const getCustomerListStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof customerListStores>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof customerListStores>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCustomerListStoresQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof customerListStores>>
  > = ({ signal }) => customerListStores({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof customerListStores>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CustomerListStoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof customerListStores>>
>;
export type CustomerListStoresQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all stores where the authenticated customer has placed orders or appointments
 */

export function useCustomerListStores<
  TData = Awaited<ReturnType<typeof customerListStores>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof customerListStores>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCustomerListStoresQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get public booking page data
 */
export const getGetBookingPageUrl = (
  slug: string,
  params?: GetBookingPageParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/booking/${slug}?${stringifiedParams}`
    : `/api/booking/${slug}`;
};

export const getBookingPage = async (
  slug: string,
  params?: GetBookingPageParams,
  options?: RequestInit,
): Promise<GetBookingPage200> => {
  return customFetch<GetBookingPage200>(getGetBookingPageUrl(slug, params), {
    ...options,
    method: "GET",
  });
};

export const getGetBookingPageQueryKey = (
  slug: string,
  params?: GetBookingPageParams,
) => {
  return [`/api/booking/${slug}`, ...(params ? [params] : [])] as const;
};

export const getGetBookingPageQueryOptions = <
  TData = Awaited<ReturnType<typeof getBookingPage>>,
  TError = ErrorType<void>,
>(
  slug: string,
  params?: GetBookingPageParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBookingPage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBookingPageQueryKey(slug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingPage>>> = ({
    signal,
  }) => getBookingPage(slug, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBookingPage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBookingPageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBookingPage>>
>;
export type GetBookingPageQueryError = ErrorType<void>;

/**
 * @summary Get public booking page data
 */

export function useGetBookingPage<
  TData = Awaited<ReturnType<typeof getBookingPage>>,
  TError = ErrorType<void>,
>(
  slug: string,
  params?: GetBookingPageParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBookingPage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBookingPageQueryOptions(slug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get available dates for a service
 */
export const getGetBookingAvailableDatesUrl = (
  slug: string,
  params: GetBookingAvailableDatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/booking/${slug}/available-dates?${stringifiedParams}`
    : `/api/booking/${slug}/available-dates`;
};

export const getBookingAvailableDates = async (
  slug: string,
  params: GetBookingAvailableDatesParams,
  options?: RequestInit,
): Promise<GetBookingAvailableDates200> => {
  return customFetch<GetBookingAvailableDates200>(
    getGetBookingAvailableDatesUrl(slug, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetBookingAvailableDatesQueryKey = (
  slug: string,
  params?: GetBookingAvailableDatesParams,
) => {
  return [
    `/api/booking/${slug}/available-dates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBookingAvailableDatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBookingAvailableDates>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: GetBookingAvailableDatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBookingAvailableDates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBookingAvailableDatesQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBookingAvailableDates>>
  > = ({ signal }) =>
    getBookingAvailableDates(slug, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBookingAvailableDates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBookingAvailableDatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBookingAvailableDates>>
>;
export type GetBookingAvailableDatesQueryError = ErrorType<unknown>;

/**
 * @summary Get available dates for a service
 */

export function useGetBookingAvailableDates<
  TData = Awaited<ReturnType<typeof getBookingAvailableDates>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: GetBookingAvailableDatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBookingAvailableDates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBookingAvailableDatesQueryOptions(
    slug,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get available time slots
 */
export const getGetBookingSlotsUrl = (
  slug: string,
  params: GetBookingSlotsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/booking/${slug}/slots?${stringifiedParams}`
    : `/api/booking/${slug}/slots`;
};

export const getBookingSlots = async (
  slug: string,
  params: GetBookingSlotsParams,
  options?: RequestInit,
): Promise<GetBookingSlots200> => {
  return customFetch<GetBookingSlots200>(getGetBookingSlotsUrl(slug, params), {
    ...options,
    method: "GET",
  });
};

export const getGetBookingSlotsQueryKey = (
  slug: string,
  params?: GetBookingSlotsParams,
) => {
  return [`/api/booking/${slug}/slots`, ...(params ? [params] : [])] as const;
};

export const getGetBookingSlotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBookingSlots>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: GetBookingSlotsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBookingSlots>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBookingSlotsQueryKey(slug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingSlots>>> = ({
    signal,
  }) => getBookingSlots(slug, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBookingSlots>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBookingSlotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBookingSlots>>
>;
export type GetBookingSlotsQueryError = ErrorType<unknown>;

/**
 * @summary Get available time slots
 */

export function useGetBookingSlots<
  TData = Awaited<ReturnType<typeof getBookingSlots>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  params: GetBookingSlotsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBookingSlots>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBookingSlotsQueryOptions(slug, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a booking appointment
 */
export const getBookAppointmentUrl = (slug: string) => {
  return `/api/booking/${slug}/book`;
};

export const bookAppointment = async (
  slug: string,
  bookAppointmentBody: BookAppointmentBody,
  options?: RequestInit,
): Promise<BookAppointment201> => {
  return customFetch<BookAppointment201>(getBookAppointmentUrl(slug), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bookAppointmentBody),
  });
};

export const getBookAppointmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bookAppointment>>,
    TError,
    { slug: string; data: BodyType<BookAppointmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bookAppointment>>,
  TError,
  { slug: string; data: BodyType<BookAppointmentBody> },
  TContext
> => {
  const mutationKey = ["bookAppointment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bookAppointment>>,
    { slug: string; data: BodyType<BookAppointmentBody> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return bookAppointment(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BookAppointmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof bookAppointment>>
>;
export type BookAppointmentMutationBody = BodyType<BookAppointmentBody>;
export type BookAppointmentMutationError = ErrorType<unknown>;

/**
 * @summary Create a booking appointment
 */
export const useBookAppointment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bookAppointment>>,
    TError,
    { slug: string; data: BodyType<BookAppointmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bookAppointment>>,
  TError,
  { slug: string; data: BodyType<BookAppointmentBody> },
  TContext
> => {
  return useMutation(getBookAppointmentMutationOptions(options));
};

/**
 * @summary Get dashboard KPI stats
 */
export const getGetDashboardStatsUrl = () => {
  return `/api/dashboard/stats`;
};

export const getDashboardStats = async (
  options?: RequestInit,
): Promise<DashboardStats> => {
  return customFetch<DashboardStats>(getGetDashboardStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardStatsQueryKey = () => {
  return [`/api/dashboard/stats`] as const;
};

export const getGetDashboardStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardStatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardStats>>
  > = ({ signal }) => getDashboardStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardStats>>
>;
export type GetDashboardStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get dashboard KPI stats
 */

export function useGetDashboardStats<
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
